import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import ModalDlg from 'components/Basic/ModalDlg';
import { ArrowForward } from '@material-ui/icons';

function NitConfirmModal({ title, subtitle, isOpenModal, onCancel, onOk }) {
  return (
    <ModalDlg className="nit_confirm_modal" handleCancel={onCancel} isCenter visible={isOpenModal} width={634}>
      <div className="modal_header">
        <h3>{title}</h3>
        <p className="description">{subtitle}</p>
      </div>
      <div className="modal_footer">
        <div className="btn_wrapper">
          <p onClick={onCancel}>Ingresar un NIT</p>
          <Button className="remove_btn" onClick={onOk}>
            Continuar sin NIT
            <ArrowForward />
          </Button>
        </div>
      </div>
    </ModalDlg>
  );
}

NitConfirmModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onOk: PropTypes.func.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  isOpenModal: PropTypes.bool,
};

NitConfirmModal.defaultProps = {
  isOpenModal: false,
  title: '',
  subtitle: '',
};

export default NitConfirmModal;
